module.exports = __webpack_public_path__ + "img/speaker-medium-volume.ce9bb49b.png";